import React from 'react';
import { Button, CardGroup, Paper, ValueCard } from 'library';

import { INQUIRY_URL } from '../../../constants/links';
import content from './content';

import './WhyHometapCards.scss';

const WhyHometapCards = () => {
  return (
    <Paper theme="medium">
      <CardGroup preventOrphans cardAlignment="center" className="WhyHometapCards">
        {content.map(({ icon, title, text }) => (
          <ValueCard icon={icon} title={title} key={title}>
            <div>{text}</div>
          </ValueCard>
        ))}
      </CardGroup>
      <Button type="button" size="normal" theme="solid" className="WhyHometapCardsButton" href={INQUIRY_URL}>
        Get an Estimate
      </Button>
    </Paper>
  );
};

export default WhyHometapCards;
